const texts = {
    "en": {
        "title": "Too Simple Encrypt",
        "secretly_share": "Secretly share a key",
        "notice": "*Currently, this tool only ensures secrecy, not integrity or authenticity. Everything will reset on refresh.",
        "one_person": "0. One person will click this button so there is 1 Alice and 1 Bob:",
        "switch_role": "Switch role",
        "you_are_alice": "You are Alice",
        "you_are_bob": "You are Bob",
        "alice_receive_box1": "1. Receive box 1 from other and paste it here",
        "alice_send_box2": "2. Copy this and sent to other (click to copy)",
        "bob_send_box1": "1. Send this to other (click to copy)",
        "bob_receive_box2": "2. Receive box 2 from other and paste it here",
        "shared_key": "Shared key",
        "shared_key_instruction": "3. After both has finished all above steps, this shared key can be saved. Next time you can skip above steps by pasting the shared key here:",
        "encrypt_decrypt": "Encrypt/Decrypt with shared key",
        "to_encrypt": "To encrypt:",
        "put_text_to_encrypt": "4e. Put text to encrypt here",
        "send_encrypted_text": "5e. Send this to other (click to copy)",
        "to_decrypt": "To decrypt:",
        "paste_encrypted_text": "4d. Paste encrypt box 5e from other here",
        "decrypted_text": "5d. Decrypted text (click to copy)",
        "copy": "Copy",
        "copied": "Copied!",
        "clear": "Clear",
    },
    "zh": {
        "title": "图森破加密",
        "secretly_share": "秘密地共享密钥",
        "notice": "*目前，本工具只能确保保密性，而不能保证完整性和真实性等。刷新页面会重置一切。",
        "one_person": "0. 其中一人需点击这个按钮，保证有1个Alice和1个Bob：",
        "switch_role": "切换角色",
        "you_are_alice": "你是Alice",
        "you_are_bob": "你是Bob",
        "alice_receive_box1": "1. 从对方接收框1并粘贴在这里",
        "alice_send_box2": "2. 复制此内容并发送给对方（点击复制）",
        "bob_send_box1": "1. 发送此内容给对方（点击复制）",
        "bob_receive_box2": "2. 从对方接收框2并粘贴在这里",
        "shared_key": "共享密钥",
        "shared_key_instruction": "3. 在双方都完成上述步骤后，可以将此共享密钥保存。下次可以直接粘贴共享密钥并跳过上述步骤：",
        "encrypt_decrypt": "使用共享密钥加密/解密",
        "to_encrypt": "加密：",
        "put_text_to_encrypt": "4e. 将要加密的文本放在这里",
        "send_encrypted_text": "5e. 将此内容发送给对方（点击复制）",
        "to_decrypt": "解密：",
        "paste_encrypted_text": "4d. 将对方的框5e粘贴在这里",
        "decrypted_text": "5d. 解密文本（点击复制）",
        "copy": "复制",
        "copied": "已复制!",
        "clear": "清除",
    }
};
export default texts;